//  @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import RegistrationDateBuilder from './RegistrationDateBuilder.js';

// Actions
import { selectRegDate } from 'store/reducers/appointment/actions';

// Selectors
import {
  getYear,
  getVehicleRegDate,
  vehicleEditableEnabled
} from 'store/reducers/appointment/selectors';
import {
  getLanguageCode,
  getLocaleCode
} from 'store/reducers/dealerLocale/selectors';

const mapStateToProps = state => ({
  vehicleYear: getYear(state),
  regDate: getVehicleRegDate(state),
  vehicleEditableEnabled: vehicleEditableEnabled(state),
  languageCode: getLanguageCode(state),
  localeCode: getLocaleCode(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    { selectRegDate }
  )
)(RegistrationDateBuilder);



// WEBPACK FOOTER //
// ./src/components/molecules/RegistrationDateBuilder/RegistrationDateBuilderContainer.js